import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY

export const isSupabaseConfigured = Boolean(url && anon)

if (!isSupabaseConfigured) {
  // Não quebra o app: mostra aviso de configuração na UI (ver App.tsx).
  console.warn(
    '[EasyMoney] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY não definidos. ' +
      'Copie .env.example para .env e preencha.',
  )
}

// Cliente sem tipos gerados na Fase 0 (usamos casts explícitos com src/types/db).
// Na Fase 1: rodar `supabase gen types typescript` e aplicar o generic <Database>.
export const supabase = createClient(
  url ?? 'http://localhost:54321',
  anon ?? 'public-anon-key-placeholder',
)
